export default function Services() {
  return (
    <div id="services" className="our-services section my-5">
      <div className="container">
        <div className="row">
          <div
            className="col-lg-6 align-self-center wow fadeInLeft"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
          >
            <div className="left-image">
              <img src="assets/images/join.png" alt="" />
            </div>
          </div>
          <div
            className="col-lg-6 wow fadeInRight"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
          >
            <div className="section-heading">
              <h2>Sponsorship Opportunities</h2>
              <h3>
                Looking to showcase your brand to active agents and
                decision-makers?
              </h3>
              <p>
                Explore our <a href="/sponsorship">Sponsorship Page</a> to
                reserve booth spaces, co-brand team shirts, sponsor welcome
                murals, and more.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
